import { Component, Input, OnChanges } from '@angular/core';
import { Image, ImageGroup } from '@spartacus/core';
import { Media, MediaComponent, MediaContainer } from '@spartacus/storefront';

@Component({
  selector: 'app-gg-media-with-mobile-media',
  templateUrl: 'gg-media-with-mobile-media.component.html',
  standalone: false,
})
export class GgMediaWithMobileMediaComponent extends MediaComponent implements OnChanges {
  @Input() mobileContainer: MediaContainer | Image | ImageGroup | ImageGroup[] | undefined;

  mobileMedia: Media | undefined;

  override ngOnChanges(): void {
    this.create();
  }

  protected override create(): void {
    this.media = this.mediaService.getMedia(
      this.container instanceof Array ? this.container[0] : this.container,
      this.format,
      this.alt,
      this.role
    )!;

    this.mobileMedia = this.mediaService.getMedia(
      this.mobileContainer instanceof Array ? this.mobileContainer[0] : this.mobileContainer,
      this.format,
      this.alt,
      this.role
    );

    if (!this.media?.src) {
      this.handleMissing();
    }
  }
}
